export const CB_LOGIN = 'CB_LOGIN';
export const ORG_LEGAL_TERMS_ACCEPTED = 'ORG_LEGAL_TERMS_ACCEPTED';